// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// // Async thunk for fetching companies
// export const fetchCompanies = createAsyncThunk(
//   "companies/fetchCompanies",
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await fetch(
//         "http://localhost:3000/super-admin/company-details"
//       );
//       const result = await response.json();

//       if (result.success) {
//         // Map API response to table format
//         const mappedCompanies = result.data.companies.map((company) => ({
//           id: company.company_id,
//           name: company.company_name || "N/A",
//           email: company.admin_email || "N/A",
//           registrationDate: company.created_at
//             ? new Date(company.created_at)
//                 .toLocaleDateString("en-GB", {
//                   day: "2-digit",
//                   month: "short",
//                   year: "numeric",
//                 })
//                 .replace(",", " -")
//                 .toUpperCase()
//             : "N/A",
//           country: company.location || "N/A",
//           website: company.website || "N/A",
//           companySize: company.company_size || "N/A",
//           activityStatus: company.status || "Inactive",
//           postJob: "-",
//           importCandidates: "-",
//           conductAssessment: "-",
//           buildRecruitmentPipeline: "-",
//         }));

//         return mappedCompanies;
//       } else {
//         return rejectWithValue(result.message || "Failed to fetch companies");
//       }
//     } catch (error) {
//       return rejectWithValue("Error fetching data: " + error.message);
//     }
//   }
// );

// const companiesSlice = createSlice({
//   name: "companies",
//   initialState: {
//     companies: [],
//     loading: false,
//     error: null,
//     searchTerm: "",
//     filters: {
//       products: "",
//       country: "",
//       annualValue: "",
//       industry: "",
//     },
//     currentPage: 1,
//     itemsPerPage: 10,
//   },
//   reducers: {
//     setSearchTerm: (state, action) => {
//       state.searchTerm = action.payload;
//       state.currentPage = 1; // Reset to first page when search changes
//     },
//     setFilters: (state, action) => {
//       state.filters = { ...state.filters, ...action.payload };
//       state.currentPage = 1; // Reset to first page when filters change
//     },
//     setCurrentPage: (state, action) => {
//       state.currentPage = action.payload;
//     },
//     setItemsPerPage: (state, action) => {
//       state.itemsPerPage = action.payload;
//       state.currentPage = 1; // Reset to first page when items per page changes
//     },
//     clearError: (state) => {
//       state.error = null;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchCompanies.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchCompanies.fulfilled, (state, action) => {
//         state.loading = false;
//         state.companies = action.payload;
//         state.error = null;
//       })
//       .addCase(fetchCompanies.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//   },
// });

// export const {
//   setSearchTerm,
//   setFilters,
//   setCurrentPage,
//   setItemsPerPage,
//   clearError,
// } = companiesSlice.actions;

// export default companiesSlice.reducer;

// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// // Get API base URL from environment variables
// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// // Async thunk for fetching companies
// export const fetchCompanies = createAsyncThunk(
//   "companies/fetchCompanies",
//   async (_, { rejectWithValue }) => {
//     try {
//       console.log("API URL:", `${API_BASE_URL}/super-admin/company-details`);

//       const response = await fetch(
//         `${API_BASE_URL}/super-admin/company-details`,
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             // Add any auth headers if needed
//             // 'Authorization': `Bearer ${token}`,
//           },
//         }
//       );

//       console.log("Response status:", response.status);
//       console.log("Response headers:", response.headers);

//       // Check if response is ok
//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }

//       // Check if response is JSON
//       const contentType = response.headers.get("content-type");
//       if (!contentType || !contentType.includes("application/json")) {
//         const textResponse = await response.text();
//         console.error("Non-JSON response:", textResponse);
//         throw new Error("Server returned non-JSON response");
//       }

//       const result = await response.json();
//       console.log("API Response:", result);

//       if (result.success) {
//         // Map API response to table format
//         const mappedCompanies = result.data.companies.map((company) => ({
//           id: company.company_id,
//           name: company.company_name || "N/A",
//           email: company.admin_email || "N/A",
//           registrationDate: company.created_at
//             ? new Date(company.created_at)
//                 .toLocaleDateString("en-GB", {
//                   day: "2-digit",
//                   month: "short",
//                   year: "numeric",
//                 })
//                 .replace(",", " -")
//                 .toUpperCase()
//             : "N/A",
//           country: company.location || "N/A",
//           website: company.website || "N/A",
//           companySize: company.company_size || "N/A",
//           activityStatus: company.status || "Inactive",
//           postJob: "-",
//           importCandidates: "-",
//           conductAssessment: "-",
//           buildRecruitmentPipeline: "-",
//         }));

//         return mappedCompanies;
//       } else {
//         return rejectWithValue(result.message || "Failed to fetch companies");
//       }
//     } catch (error) {
//       return rejectWithValue("Error fetching data: " + error.message);
//     }
//   }
// );

// const companiesSlice = createSlice({
//   name: "companies",
//   initialState: {
//     companies: [],
//     loading: false,
//     error: null,
//     searchTerm: "",
//     filters: {
//       products: "",
//       country: "",
//       annualValue: "",
//       industry: "",
//     },
//     currentPage: 1,
//     itemsPerPage: 10,
//   },
//   reducers: {
//     setSearchTerm: (state, action) => {
//       state.searchTerm = action.payload;
//       state.currentPage = 1; // Reset to first page when search changes
//     },
//     setFilters: (state, action) => {
//       state.filters = { ...state.filters, ...action.payload };
//       state.currentPage = 1; // Reset to first page when filters change
//     },
//     setCurrentPage: (state, action) => {
//       state.currentPage = action.payload;
//     },
//     setItemsPerPage: (state, action) => {
//       state.itemsPerPage = action.payload;
//       state.currentPage = 1; // Reset to first page when items per page changes
//     },
//     clearError: (state) => {
//       state.error = null;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchCompanies.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchCompanies.fulfilled, (state, action) => {
//         state.loading = false;
//         state.companies = action.payload;
//         state.error = null;
//       })
//       .addCase(fetchCompanies.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//   },
// });

// export const {
//   setSearchTerm,
//   setFilters,
//   setCurrentPage,
//   setItemsPerPage,
//   clearError,
// } = companiesSlice.actions;

// export default companiesSlice.reducer;

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// Get API base URL from environment variables
const API_BASE_URL = process.env.REACT_APP_SUPERADMIN_APP_API_BASE_URL;

// Async thunk for fetching companies
export const fetchCompanies = createAsyncThunk(
  "companies/fetchCompanies",
  async (_, { rejectWithValue }) => {
    try {
      console.log("API URL:", `${API_BASE_URL}/super-admin/company-details`);

      const response = await fetch(
        `${API_BASE_URL}/super-admin/company-details`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            // Add any auth headers if needed
            // 'Authorization': `Bearer ${token}`,
          },
        }
      );

      console.log("Response status:", response.status);
      console.log("Response headers:", response.headers);

      // Check if response is ok
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // Check if response is JSON
      const contentType = response.headers.get("content-type");
      if (!contentType || !contentType.includes("application/json")) {
        const textResponse = await response.text();
        console.error("Non-JSON response:", textResponse);
        throw new Error("Server returned non-JSON response");
      }

      const result = await response.json();
      console.log("API Response:", result);

      if (result.success) {
        // Map API response to table format with flow counts
        const mappedCompanies = result.data.companies.map((company) => ({
          id: company.company_id,
          name: company.company_name || "N/A",
          email: company.admin_email || "N/A",
          registrationDate: company.created_at
            ? new Date(company.created_at)
                .toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })
                .replace(",", " -")
                .toUpperCase()
            : "N/A",
          country: company.location || "N/A",
          website: company.website || "N/A",
          companySize: company.company_size || "N/A",
          activityStatus: company.status || "Inactive",
          // Map flow counts from backend
          postJob: company.flow1Count || 0,
          importCandidates: company.flow2Count || 0,
          conductAssessment: company.flow3Count || 0,
          buildRecruitmentPipeline: company.flow4Count || 0,
          // Add total flow usage if needed
          totalFlowUsage: company.totalFlowUsage || 0,
          // Add team member count
          teamMemberCount: company.teamMemberCount || 0,
        }));

        return mappedCompanies;
      } else {
        return rejectWithValue(result.message || "Failed to fetch companies");
      }
    } catch (error) {
      return rejectWithValue("Error fetching data: " + error.message);
    }
  }
);

const companiesSlice = createSlice({
  name: "companies",
  initialState: {
    companies: [],
    loading: false,
    error: null,
    searchTerm: "",
    filters: {
      products: "",
      country: "",
      annualValue: "",
      industry: "",
    },
    currentPage: 1,
    itemsPerPage: 10,
  },
  reducers: {
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
      state.currentPage = 1; // Reset to first page when search changes
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
      state.currentPage = 1; // Reset to first page when filters change
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setItemsPerPage: (state, action) => {
      state.itemsPerPage = action.payload;
      state.currentPage = 1; // Reset to first page when items per page changes
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanies.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCompanies.fulfilled, (state, action) => {
        state.loading = false;
        state.companies = action.payload;
        state.error = null;
      })
      .addCase(fetchCompanies.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  setSearchTerm,
  setFilters,
  setCurrentPage,
  setItemsPerPage,
  clearError,
} = companiesSlice.actions;

export default companiesSlice.reducer;
// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// // Async thunk for fetching companies
// export const fetchCompanies = createAsyncThunk(
//   "companies/fetchCompanies",
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await fetch(
//         `${process.env.REACT_NewAPP_API_URL}/super-admin/company-details`
//       );
//       const result = await response.json();

//       if (result.success) {
//         // Map API response to table format
//         const mappedCompanies = result.data.companies.map((company) => ({
//           id: company.company_id,
//           name: company.company_name || "N/A",
//           email: company.admin_email || "N/A",
//           registrationDate: company.created_at
//             ? new Date(company.created_at)
//                 .toLocaleDateString("en-GB", {
//                   day: "2-digit",
//                   month: "short",
//                   year: "numeric",
//                 })
//                 .replace(",", " -")
//                 .toUpperCase()
//             : "N/A",
//           country: company.location || "N/A",
//           website: company.website || "N/A",
//           companySize: company.company_size || "N/A",
//           activityStatus: company.status || "Inactive",
//           postJob: "-",
//           importCandidates: "-",
//           conductAssessment: "-",
//           buildRecruitmentPipeline: "-",
//         }));

//         return mappedCompanies;
//       } else {
//         return rejectWithValue(result.message || "Failed to fetch companies");
//       }
//     } catch (error) {
//       return rejectWithValue("Error fetching data: " + error.message);
//     }
//   }
// );

// const companiesSlice = createSlice({
//   name: "companies",
//   initialState: {
//     companies: [],
//     loading: false,
//     error: null,
//     searchTerm: "",
//     filters: {
//       products: "",
//       country: "",
//       annualValue: "",
//       industry: "",
//     },
//     currentPage: 1,
//     itemsPerPage: 10,
//   },
//   reducers: {
//     setSearchTerm: (state, action) => {
//       state.searchTerm = action.payload;
//       state.currentPage = 1; // Reset to first page when search changes
//     },
//     setFilters: (state, action) => {
//       state.filters = { ...state.filters, ...action.payload };
//       state.currentPage = 1; // Reset to first page when filters change
//     },
//     setCurrentPage: (state, action) => {
//       state.currentPage = action.payload;
//     },
//     setItemsPerPage: (state, action) => {
//       state.itemsPerPage = action.payload;
//       state.currentPage = 1; // Reset to first page when items per page changes
//     },
//     clearError: (state) => {
//       state.error = null;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchCompanies.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchCompanies.fulfilled, (state, action) => {
//         state.loading = false;
//         state.companies = action.payload;
//         state.error = null;
//       })
//       .addCase(fetchCompanies.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//   },
// });

// export const {
//   setSearchTerm,
//   setFilters,
//   setCurrentPage,
//   setItemsPerPage,
//   clearError,
// } = companiesSlice.actions;

// export default companiesSlice.reducer;
